import script from "./DRecordPopover.vue?vue&type=script&setup=true&lang=js"
export * from "./DRecordPopover.vue?vue&type=script&setup=true&lang=js"

import "./DRecordPopover.vue?vue&type=style&index=0&id=4898c894&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4898c894"]])

export default __exports__